import Loader from './components/Loader';
import ErrorPage from './pages/ErrorPage';
import AuthLayout from './layouts/AuthLayout';
import MainLayout from './layouts/MainLayout';
import { Fragment, useEffect, useState } from 'react';
import { getCurrentUser } from './actions/authActions';
import { appRoutes, authRoutes } from './config/routes';
import { useGlobalStore } from './store/useGlobalStore';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { getCookieByValue, inApp } from './utils/helpers';
import { basename } from './utils/env';
import { Route, Routes, Navigate } from 'react-router-dom';
import DynamicComponentLoader from './DynamicComponentLoader';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

function App(): JSX.Element {
  const [loading, setLoading] = useState(false)
  const { user } = useGlobalStore()
  // Check for authenticated cookie instead of access_token
  const isAuthenticated = getCookieByValue("authenticated") === 'true'
  
  // Debug authentication state
  console.log('App render - Authentication state:', {
    isAuthenticated,
    userExists: !!user,
    path: window.location.pathname,
    cookies: document.cookie
  })

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      console.log('App initialization - authenticated:', isAuthenticated ? 'Yes' : 'No');
      console.log('Current path:', window.location.pathname);
      console.log('inApp() check result:', inApp());
      console.log('User state:', user ? 'User exists' : 'No user');
      
      // If we're in the app section but don't have user data yet
      if (inApp()) {
        if (!user) {
          if (isAuthenticated) {
            console.log('In app with authentication but no user - fetching user data');
            const success = await getCurrentUser();
            console.log('getCurrentUser result:', success ? 'Success' : 'Failed');
          } else {
            console.log('In app without authentication - redirecting to login');
            window.location.href = `${window.location.origin}${basename}/auth/login`;
          }
        }
      } else if (isAuthenticated && window.location.pathname.includes('/auth/login')) {
        // If we're authenticated but still on the login page, force redirect to app
        console.log('Authenticated but on login page - redirecting to app');
        window.location.href = `${window.location.origin}${basename}/app/welcome`;
      }
      
      setLoading(false)
    };

    fetchData();
    return () => { };
  }, [user, inApp, isAuthenticated]);

  return (
    loading ?
      <Loader /> :
      <Routes>
        <Route index element={isAuthenticated ? <Navigate to="/app/welcome" replace /> : <Navigate to="/auth/login" replace />} />
        {isAuthenticated ?
          <Fragment>
            <Route path='auth/*' element={<Navigate to="/app/welcome" replace />} />
            <Route path='app' Component={MainLayout}>
              {appRoutes.map(route => (
                <Route key={route.key} path={route.path} element={<DynamicComponentLoader componentName={route.component} />} />
              ))}
              <Route index element={<Navigate to="welcome" replace />} />
              <Route path='*' element={<ErrorPage />} />
            </Route>
          </Fragment>
          :
          <Fragment>
            <Route path='app/*' element={<Navigate to="/auth/login" replace />} />
            <Route path='auth' Component={AuthLayout}>
              {authRoutes.map(route => (
                <Route key={route.key} path={route.path} element={<DynamicComponentLoader componentName={route.component} />} />
              ))}
              <Route index element={<Navigate to="/auth/login" replace />} />
              <Route path='*' element={<Navigate to="/auth/login" replace />} />
            </Route>
          </Fragment>
        }
        <Route key={14} path='*' element={isAuthenticated ? <Navigate to="/app/welcome" replace /> : <Navigate to="/auth/login" replace />} />
      </Routes>
  );
}

export default App;
